// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  isMockEnabled: false, // You have to switch this, when your real back-end is done
	Authorization: 'Base64 YWRtaW46YWRtaW5AMzIx',
	api: {
		// apiURL: window.location.protocol + "//preskil.fortiddns.com:8021/api/v2"
		apiURL: window.location.protocol + "//sun.smartpoint.in/api/v2"
		//apiURL: window.location.protocol + "//wyntronix.smartpoint.in/api/v2"
	}
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
